import ErrorRouteFetch from '@components/error-route-fetch/ErrorRouteFetch';
import Feedback from '@components/feedback/Feedback';
import PendingElement from '@components/pending-element/PendingElement';
import ProviderConfiguration from '@components/provider-configuration/ProviderConfiguration';
import ScrollToTop from '@components/scroll-to-top/ScrollToTop';
import { FilterRoutesFn, Outlet, ReactLocation, Router } from '@tanstack/react-location';
import { rankRoutes } from '@tanstack/react-location-rank-routes';
import React from 'react';
import routers from 'router.config';
import './App.css';
import './globals';

const location = new ReactLocation();

const App: React.FC = () => {
  return (
    <ProviderConfiguration>
      <Router
        basepath="/digitalipo"
        location={location}
        filterRoutes={rankRoutes as FilterRoutesFn}
        routes={routers}
        defaultPendingElement={<PendingElement />}
        defaultErrorElement={<ErrorRouteFetch />}
        defaultPendingMs={100}
        defaultPendingMinMs={100}
      >
        <>
          <Outlet />
          <ScrollToTop />
        </>
      </Router>
      <Feedback />
    </ProviderConfiguration>
  );
};

export default App;
